import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { components, contentfulModels } from '@glowforge/ui-common';
import { orderPropType } from 'app/selectors/user';
import { shopifyMultipassUrlBuilder } from 'app/util';

import Order from './order';

import './purchase-history.less';

const { Button } = components;
const { pageStringsPropType } = contentfulModels;

function getString(strings, key, defaultValue) {
  return _.get(strings, key, defaultValue);
}

const ShopifyAccountLink = (props) => {
  const { pageStrings } = props;
  const accountUrl = shopifyMultipassUrlBuilder('/account', false);
  const text = getString(
    pageStrings,
    'settings-purchase-history-shopify-link-text',
    'Newer orders may be here');

  return (
    <div className='shopifyAccountLinkContainer'>
      <a href={accountUrl}>{text}</a>
    </div>
  );
};

ShopifyAccountLink.propTypes = {
  pageStrings: pageStringsPropType.isRequired,
};

const ManageSubscriptionsLink = (props) => {
  const { subscriptionManageLink } = props;
  if (!props.canManageSubscriptions || _.isEmpty(subscriptionManageLink)) {
    return null;
  }

  const { pageStrings, onManageSubscriptions } = props;

  const handleUrl = (url) => {
    window.open(url, '_blank');
  };
  const onClick = (e) => {
    e.preventDefault();
    e.target.disabled = true;
    onManageSubscriptions(subscriptionManageLink, handleUrl);
  };

  const text = getString(
    pageStrings,
    'settings-purchase-history-subscriptions-link-text',
    'Manage Subscription');

  return (
    <div className='manageSubscriptionsLinkContainer'>
      <Button type='text' onClick={onClick} disabled={props.isManagePending}>{text}</Button>
    </div>
  );
};

ManageSubscriptionsLink.propTypes = {
  subscriptionManageLink: PropTypes.string.isRequired,
  onManageSubscriptions: PropTypes.func.isRequired, // eslint-disable-line
  canManageSubscriptions: PropTypes.bool.isRequired,
  isManagePending: PropTypes.bool.isRequired,
  pageStrings: pageStringsPropType.isRequired,
};

// TODO: Should this have a "loading" spinner?
const PurchaseHistory = (props) => {
  const { pageStrings } = props;

  const orders = _.map(props.purchaseHistory, (order, index) => <Order key={index} {...order} />);

  const pageHeaderText = getString(
    pageStrings,
    'settings-purchase-history-header-text',
    'Purchase History');

  const noOrdersText = getString(
    pageStrings,
    'settings-purchase-history-empty-orders-text',
    'You have no Purchase History');

  let content;
  if (_.isEmpty(orders)) {
    content = <div className='empty'>{noOrdersText}</div>;
  } else {
    content = <div className='orderList'>{orders}</div>;
  }
  return (
    <div className='PurchaseHistory'>
      <h1 className='h2'>{pageHeaderText}</h1>
      <ManageSubscriptionsLink
        pageStrings={pageStrings}
        subscriptionManageLink={props.subscriptionManageLink}
        canManageSubscriptions={props.canManageSubscriptions}
        isManagePending={props.isManagePending}
        onManageSubscriptions={props.onManageSubscriptions} />
      <ShopifyAccountLink pageStrings={pageStrings} />
      {content}
    </div>
  );
};

PurchaseHistory.propTypes = {
  purchaseHistory: PropTypes.arrayOf(PropTypes.shape(orderPropType)),
  pageStrings: pageStringsPropType.isRequired,
  subscriptionManageLink: PropTypes.string,
  canManageSubscriptions: PropTypes.bool,
  isManagePending: PropTypes.bool,
  onManageSubscriptions: PropTypes.func.isRequired, // eslint-disable-line
};

PurchaseHistory.defaultProps = {
  purchaseHistory: [],
  subscriptionManageLink: '',
  canManageSubscriptions: false,
  isManagePending: false,
};

export default PurchaseHistory;



// WEBPACK FOOTER //
// ./app/components/settings/purchase-history.jsx